import { hasTrailingSlash, trimLeadingSlash } from './utils/index';

type BuildCanonicalUrl = {
  host: string;
  pathname?: string | null;
  locale?: string;
};

/**
 * Builds a URL string from the hostname, pathname and locale
 * It checks cases to avoid missing or doubling '/' symbol
 */
export function buildCanonicalUrl({
  host,
  pathname,
  locale,
}: BuildCanonicalUrl): string {
  let pageUrl = host;
  if (locale === 'en') {
    if (!hasTrailingSlash(pageUrl)) pageUrl += '/';
    pageUrl += 'en';
  }

  if (pathname && pathname.length > 0) {
    // remove leading slash in pathname if it exist
    const cleanPath = trimLeadingSlash(pathname);
    if (!hasTrailingSlash(pageUrl)) pageUrl += '/';
    pageUrl += cleanPath;
  }

  return pageUrl;
}
